export const CLICK = "click";

export const EVENT_TRIGGERS = [
  CLICK
];



// WEBPACK FOOTER //
// ./src/constants/eventTriggers.js